(() => {
  if (window.playNavigationReady) return;
  window.playNavigationReady = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-play-header] details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    const link = event.target.closest('[data-play-header] a');
    if (link) link.closest('[data-play-disclosure]')?.removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelectorAll('[data-play-header] details[open]');
    const focused = document.activeElement;
    let summary;
    open.forEach((details) => {
      if (!summary && details.contains(focused)) summary = details.querySelector('summary');
      details.open = false;
    });
    summary?.focus();
  });
})();
